import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const contactSupportApi = createApi({
    reducerPath: "contactSupport",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["ContactSupport"],
    endpoints: (builder) => ({
        contactSupport: builder.mutation({
            query: (data) => ({
                url: `/contact-us`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["ContactSupport"],
        }),
        getContactSupport: builder.query({
            query: ({ page, status, keyword, limit }) => {
                let url = `/admin/contact-us?page=${page + 1}`;
                if (status) {
                    url += `&status=${status}`;
                }
                if (keyword) {
                    url += `&keyword=${keyword}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                return {
                    url,
                    method: "GET",
                }
            },
            providesTags: ["ContactSupport"],

        }),
        contactSupportReply: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/contact-us/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["ContactSupport"],
        }),
    }),
});


export const {
    useContactSupportMutation,
    useGetContactSupportQuery,
    useContactSupportReplyMutation,
} = contactSupportApi;